/**
 *
 * Asynchronously loads the component for ForgotPasswordPage
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
